import { Component, Inject, OnInit, Optional } from '@angular/core';

import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { DomObjectGet, DomObjectService, DomObjectTypeItem, GetDomObjectParams } from '@app/services/dom-object.service';

@Component({
    selector: 'tt-dom-object',
    templateUrl: './dom-object.component.html',
    styleUrls: ['./dom-object.component.css'],
    standalone: false,
})
export class DomObjectComponent implements OnInit {
    public page?: DomObjectGet;

    public selectListDomObjectTypes: DomObjectTypeItem[] = [];

    constructor(
        private domObject: DomObjectService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    private async loadPage(params: GetDomObjectParams): Promise<void> {
        this.page = await this.domObject.getDomObject(params);
    }

    private async loadDomObjectTypes(): Promise<void> {
        this.selectListDomObjectTypes = await this.domObject.listDomObjectTypes();
    }

    private async init(): Promise<void> {
        const params = this.navigator?.params as GetDomObjectParams | undefined;

        if (!params) return;

        await Promise.all([this.loadPage(params), this.loadDomObjectTypes()]);
    }

    ngOnInit(): void {
        void this.init();
    }
}
